import React, {useState}  from 'react';
import { FormGroup, Button, Label } from 'reactstrap';
import RenderIcon from '../commons/RenderIcon';
import { ModelPropertiesParser } from '../commons/modelPropertiesParser';
import config from '../../config';

const PDFReader = (props) => {
    const { layoutItem: { itemProperties: { pdfReaderConfig } }, classProperty, type, workflowData, change,
        validations, value, label, isReadOne, nextState, workflow ,customIcons, formValues, ...rest } = props;
    const isLoading = nextState && nextState.isLoading ? true : false;
    const color = pdfReaderConfig && pdfReaderConfig.buttonStyle ? pdfReaderConfig.buttonStyle : 'primary';
    const outline = pdfReaderConfig && pdfReaderConfig.isOutline;
    const iconConfig = pdfReaderConfig && pdfReaderConfig.cssClass ? {
        cssClass: pdfReaderConfig.cssClass
    } : null;
    const pdfField = pdfReaderConfig && pdfReaderConfig.fileUrl;
    const fieldsToUpdate = pdfReaderConfig && pdfReaderConfig.fieldList;
    let pdfUrl = ModelPropertiesParser(`{{${pdfField}}}`, workflowData);
    pdfUrl = pdfUrl ? pdfUrl.startsWith('http') ? pdfUrl : (config.assetsBasePath + pdfUrl) : ''; 
    const [loading, setOnChangeData] = useState(false);
    
    return <div><Button data-html2canvas-ignore='true' name='pdfReader' onClick={ () => {
                    setOnChangeData(true)
                    props.getPdfData({pdfUrl: pdfUrl}).then(data => {
                        if (data.data) {
                            setOnChangeData(false)
                            const pdfData = data.data.data;
                            fieldsToUpdate && fieldsToUpdate.map((f,i)=>{
                                if(pdfData[i]){
                                    change(f.field, pdfData[i])
                                }
                            })
                        }
                    });
                   
                } }
                    disabled={props.disableLayoutItem} 
                    block 
                    color={color}
                    outline={outline}
                >
                {
                    iconConfig && !isLoading ? <RenderIcon customIcons={customIcons} config={iconConfig} /> : null
                }
                {!loading ? label.text : 'Please wait...'}
                </Button>                
            </div>
}

export default PDFReader;